export const routes = [
  {
    path: '/sala-principal/:id/sala-indicadores-fonte',
    component: () => import(/* webpackChunkName: "ur" */ './components/List'),
    name: 'sala.indicadores.fonte.list',
    meta: {
      requiresAuth: true
    }
  }
]
